export let GlobalVariable = {
  loadingIsShow: false,
  loadingDelay: 1,
  isExternalApi: false
};
